export function getInterviewElapsedSeconds(startedAt: string, endedAt: string|null, now: number = Date.now()): number {
    const startTime = Date.parse(startedAt);
    const endTime = endedAt ? Date.parse(endedAt) : now;

    if (!Number.isFinite(startTime) || !Number.isFinite(endTime)) {
        return 0;
    }

    return Math.max(0, Math.floor((endTime - startTime) / 1000));
}

export function formatInterviewElapsedTime(totalSeconds: number): string {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const paddedMinutes = String(minutes).padStart(2, "0");
    const paddedSeconds = String(seconds).padStart(2, "0");

    return hours > 0
        ? `${String(hours).padStart(2, "0")}:${paddedMinutes}:${paddedSeconds}`
        : `${paddedMinutes}:${paddedSeconds}`;
}
